<section class="trending-brand mb-4 mb-md-5" *ngIf="isBrowser">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="trending-categories-sub">
          <div class="trending-categories rounded-lg py-3 py-md-4 px-2 px-md-5">
            <h3 class="text-center mb-4">Trending Brand</h3>
            <div class="">
              <div class="text-center">
                <owl-carousel-o [options]="customOptions">
                  <ng-container
                    (click)="onClick(brand)"
                    *ngFor="let brand of brands"
                  >
                    <ng-template carouselSlide [id]="brand.id">
                      <div class="trending trending_brand_bann">
                        <div
                          class="qrax d-flex align-items-center justify-content-center"
                        >
                          <img
                            lazyLoad="{{ brand.company.logo }}"
                            class="img-fluid"
                          />
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </owl-carousel-o>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
